import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import type { NavigationScreen } from 'app/types/navigation';
import { useTranslation } from 'react-i18next';
import { SafeAreaView } from 'react-native-safe-area-context';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { AllNotificationsContent } from './all-notifications-content';

const theme = createDSTheme();

export const NotificationsOverlayScreenComponent: NavigationScreen<'notificationsOverlay'> = ({ navigation }) => {
  const { t } = useTranslation('notifications');

  return (
    <SafeAreaView edges={['top']} style={{ backgroundColor: 'white', flex: 1 }}>
      <Column flex={1}>
        <Row
          alignItems="center"
          justifyContent="space-between"
          style={{
            borderBottomColor: 'rgba(0, 0, 0, 0.08)',
            borderBottomWidth: 1,
            paddingHorizontal: theme.spacing['spacing.general.x4'],
            paddingVertical: theme.spacing['spacing.general.x3'],
          }}
        >
          <Text fontSize={19} fontWeight="700">
            {t('tabBarLabel')}
          </Text>
          <Button
            accessibilityLabel={t('closeButtonAccessibilityLabel')}
            onPress={navigation.goBack}
            style={{
              alignItems: 'center',
              borderRadius: 18,
              height: 36,
              justifyContent: 'center',
              width: 36,
            }}
            variant="plain"
          >
            <IconX strokeWidth={ICON_STROKE_WIDTH} size={20} color={theme.colors['text.primary']} />
          </Button>
        </Row>
        <AllNotificationsContent fill screenName="NotificationsOverlayScreen" />
      </Column>
    </SafeAreaView>
  );
};
